export const requestIssueConst = {
    apiName: 'api/RequestIssue',
    getActions: '/GetActions',
    getAddNewItemActionDetails: '/GetAddNewItemActionDetails',
    newAction: 'newaction',
    addNewItem: 'addnewitem',
    getChangeDataActionDetails: '/GetChangeDataActionDetails',
    getRequestIssueTypes: '/GetRequestIssueTypes',
}